module.exports = __webpack_public_path__ + "img/新能源汽车行业数字化转型场景图谱.db9a6ce7.jpg";